export enum EProductsViewStatus {
  Loading = 'loading',
  Loaded = 'loaded',
  Error = 'Error'
}
